import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { connect } from 'react-redux';
import CartIcon from '@zola/zola-ui/src/components/SvgIcons/Cart';
import NAV_DATA from '@zola-helpers/client/dist/es/constants/navConstants';
import { isDesktop } from '@zola-helpers/client/dist/es/util/responsive';

import { showModal } from '../../../actions/ModalActions';
import { getCartSize } from '../../../actions/CartActions';

const {
  EVENTS: { OPEN_MODAL_EVENT, MODAL_TYPE_CART },
} = NAV_DATA;

class CartContainer extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.openModalEventHandler = this.openModalEventHandler.bind(this);
    this.gettingCartSizeAction = this.gettingCartSizeAction.bind(this);
  }

  componentDidMount() {
    const { handleGetCartSize } = this.props;
    handleGetCartSize();
    window.addEventListener('NAV_UPDATE_CART_SIZE', this.gettingCartSizeAction);
    window.addEventListener(OPEN_MODAL_EVENT, this.openModalEventHandler, false);
  }

  componentWillUnmount() {
    window.removeEventListener('NAV_UPDATE_CART_SIZE', this.gettingCartSizeAction);
    window.removeEventListener(OPEN_MODAL_EVENT, this.openModalEventHandler);
  }

  gettingCartSizeAction() {
    const { handleGetCartSize } = this.props;
    handleGetCartSize();
  }

  openModalEventHandler(event) {
    if (event.detail === 'CART') {
      const { openModal } = this.props;
      openModal(MODAL_TYPE_CART, {}, { ariaLabel: 'Cart' });
    }
  }

  handleClick(e) {
    const { openModal, onClick } = this.props;
    e.preventDefault();
    if (typeof onClick === 'function') onClick();
    openModal(MODAL_TYPE_CART, {}, { ariaLabel: 'Cart' });
  }

  render() {
    const { cartSize, isNavV2, className } = this.props;
    const cartIconSize = isDesktop() ? 40 : 24;

    return (
      <a
        aria-label="Cart"
        className={cx('top-nav__cart icon-link', className, { 'nav-util__cart': isNavV2 })}
        href="/checkout/cart"
        onClick={this.handleClick}
      >
        {isNavV2 ? (
          <CartIcon className="nav-util__icon" width={cartIconSize} height={cartIconSize} />
        ) : (
          <i className="zolaicon zolaicon-cart" />
        )}
        {cartSize > 0 && <span className="badge">{cartSize}</span>}
      </a>
    );
  }
}

CartContainer.propTypes = {
  openModal: PropTypes.func.isRequired,
  cartSize: PropTypes.number,
  handleGetCartSize: PropTypes.func.isRequired,
  isNavV2: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

const mapStateToProps = (state) => ({
  cartSize: state.cart.size,
});

const mapDispatchToProps = (dispatch) => ({
  openModal: (modalType, modalProps, modalOptions) => {
    dispatch(showModal(modalType, modalProps, modalOptions));
  },
  handleGetCartSize: () => dispatch(getCartSize()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CartContainer);
